import React from "react";
import { Link, Outlet } from "react-router-dom";

const VerifyRepo = () => {
  return (
    <>
      <div>hiddeaf</div>
      <Link to="/">hi</Link>
    </>
  );
};
export default VerifyRepo;
